<template>
  <HomeView />
</template>

<script>
import HomeView from "@/components/Home";
export default {
  name: "Home",
  components: {
    HomeView,
  },
};
</script>
